/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thankyou_ReturnInputs */

const en_thankyou_return = /** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to Mission Control`)
};

const es_thankyou_return = /** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regresar al Control de Misión`)
};

const fr_thankyou_return = /** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour au Centre de Contrôle`)
};

const de_thankyou_return = /** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zur Missionskontrolle`)
};

const id_thankyou_return = /** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke Kendali Misi`)
};

/** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */
const ja_thankyou_return = en_thankyou_return;

/** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */
const zh_thankyou_return = en_thankyou_return;

/** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */
const ar_thankyou_return = en_thankyou_return;

/** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */
const it_thankyou_return = en_thankyou_return;

/** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */
const ru_thankyou_return = en_thankyou_return;

/** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */
const pt_thankyou_return = en_thankyou_return;

/** @type {(inputs: Thankyou_ReturnInputs) => LocalizedString} */
const ko_thankyou_return = en_thankyou_return;

/**
* | output |
* | --- |
* | "Return to Mission Control" |
*
* @param {Thankyou_ReturnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const thankyou_return = /** @type {((inputs?: Thankyou_ReturnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thankyou_ReturnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thankyou_return(inputs)
	if (locale === "es") return es_thankyou_return(inputs)
	if (locale === "fr") return fr_thankyou_return(inputs)
	if (locale === "de") return de_thankyou_return(inputs)
	if (locale === "ja") return ja_thankyou_return(inputs)
	if (locale === "zh") return zh_thankyou_return(inputs)
	if (locale === "ar") return ar_thankyou_return(inputs)
	if (locale === "id") return id_thankyou_return(inputs)
	if (locale === "it") return it_thankyou_return(inputs)
	if (locale === "ru") return ru_thankyou_return(inputs)
	if (locale === "pt") return pt_thankyou_return(inputs)
	return ko_thankyou_return(inputs)
});